<template>
    <div class="loginPage">
        <div class="loginPanel">
            <form class="form">
                <div class="title">
                    <p>
                        <a href="#"><img src="../../../../assets/images/head_logo_zj.png" border="3"/></a>
                    </p>
                </div>
                <div class="content">
                    <a class="content-hy">会员登录</a>
                    <a @click="listView" class="content-fhy">非会员登录</a>
                    <span class="content-yhm">用户名</span>
                    <input
                        class="yhm"
                        type="text"
                        ref="userName"
                        v-model="userName"
                        autocomplete="off"
                        placeholder=""
                        @keypress.enter.prevent="onUserNameEnter"
                    />
                    <span class="content-mm">密码</span>
                    <input
                        class="mm"
                        type="password"
                        ref="userPassword"
                        v-model="userPassword"
                        placeholder=""
                        autocomplete="off"
                        @keypress.enter.prevent="onUserPasswordEnter"
                    />
                    <button class="content-login" :disabled="loading" @click.stop="doLogin">{{ loading ? "登录中..." : "登录" }}</button>
                </div>
            </form>
        </div>
    </div>
</template>
<script>
import { createNamespacedHelpers, mapActions } from "vuex";
const user = createNamespacedHelpers("user");
export default {
    data() {
        return {
            // 表单绑定的数据
            userName: "",
            userPassword: "",
            // 登录
            userToken: null,
            loginLoading: false,
            // 用户信息
            userInfo: null,
            userInfoLoading: false,
            // 用户菜单
            userMenusLoading: false
        };
    },
    computed: {
        loading() {
            return this.loginLoading || this.userInfoLoading || this.userMenusLoading;
        }
    },
    methods: {
        ...user.mapActions(["setToken", "setUserInfo", "setUserMenus", "logout"]),
        ...mapActions(["setStaticVarData", "setMessageData", "setDictData", "setSelectData", "setObjVarData"]),
        onUserNameEnter(e) {
            if (this.userName) {
                this.$refs.userPassword.focus();
            }
        },
        onUserPasswordEnter() {
            if (this.userName === "") {
                this.$refs.userName.focus();
            } else {
                this.doLogin();
            }
        },
        doLogin() {
            if (this.loading) {
                return;
            }
            if (this.userName === "") {
                this.$refs.userName.focus();
                return;
            }
            // 执行登录操作
            this.loginLoading = true;
            this.$FG_http
                .post("./api/admin/user/login", { username: this.userName, password: this.userPassword, server: "company" }, { showSuccess: false })
                .then(({ success, data, errMsg }) => {
                    this.loginLoading = false;
                    if (success) {
                        this.$cookies.set("userName", this.userName);
                        // 登录成功
                        this.setToken(data.data);
                        // 获取当前用户信息
                        this.userInfoLoading = true;
                        this.$FG_http.post("./api/admin/user/getUserByToken", {}, { showSuccess: false }).then(({ success, data, errMsg }) => {
                            this.userInfoLoading = false;
                            if (success) {
                                const userInfo = data.data;
                                this.$FG_http
                                    .post("./api/admin/user/getUserDW", { id: userInfo.id }, { showSuccess: false })
                                    .then(({ success, data, errMsg }) => {
                                        if (success) {
                                            // 保存用户信息
                                            userInfo.dwid = data.data.id;
                                            userInfo.dwmc = data.data.dwmc;
                                            userInfo.dwlb = data.data.dwlb;
                                            userInfo.dwbh = data.data.dwbh;
                                            userInfo.dwlx = data.data.dwlx;
                                            userInfo.qyid = data.data.qyid;
                                            userInfo.qybh = data.data.qybh;
                                            userInfo.qymc = data.data.qymc;
                                            userInfo.dwxz = data.data.dwxz;
                                            userInfo.zxdj = data.data.zxdj;
                                            userInfo.hyfl = data.data.hyfl;
                                            userInfo.dwzt = data.data.dwzt;
                                            if (userInfo.dwlx === "会员单位" && userInfo.dwzt === "启用") {
                                                // 转到列表页
                                                this.$router.push({ name: "jsaecList" });
                                                userInfo.loginType = "会员";
                                            } else {
                                                this.$FG_message.warn("对不起,您还不是会员无法登录");
                                            }
                                            this.setUserInfo(userInfo);
                                        }
                                    });
                            } else {
                                this.$refs.userName.focus();
                            }
                        });
                    } else {
                        this.$refs.userPassword.focus();
                    }
                });
        },
        listView() {
            const userInfo = { loginType: "非会员" };
            this.setUserInfo(userInfo);
            // 转到列表页
            this.$router.push({ name: "jsaecList" });
        }
    }
};
</script>
<style lang="scss" scoped>
.loginPage {
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    background-image: url("../../../../assets/images/body_zjbg.png");
    background-repeat: no-repeat;
    background-position: 0px 0px;
    background-size: cover;
    .loginPanel {
        position: absolute;
        top: 50vh;
        left: 50vw;
        margin-top: -380px;
        margin-left: -220px;
        .form {
            .content {
                width: 360px;
                height: 350px;
                font-size: 16px;
                background-color: #fff;
                margin: 5rem auto;
                .content-hy {
                    width: 180px;
                    height: 60px;
                    color: #0000ff;
                    text-align: center;
                    line-height: 60px;
                    line-height: 60px;
                    float: left;
                    &:hover:not(:disabled) {
                        text-decoration: underline;
                    }
                }
                .content-fhy {
                    width: 180px;
                    height: 60px;
                    color: #666666;
                    text-align: center;
                    background-color: #cccccc;
                    float: right;
                    line-height: 60px;
                    &:hover:not(:disabled) {
                        text-decoration: underline;
                    }
                }
                .content-yhm {
                    display: block;
                    color: #000;
                    font-weight: 500;
                    padding-top: 100px;
                    padding-left: 40px;
                }
                .content-mm {
                    display: block;
                    color: #000;
                    font-weight: 500;
                    padding-left: 40px;
                    margin-top: 10px;
                }
                .yhm {
                    margin-left: 40px;
                    width: 80%;
                    margin-top: 3px;
                    border-width: 1px;
                }
                .mm {
                    margin-left: 40px;
                    width: 80%;
                    margin-top: 3px;
                    border-width: 1px;
                }
                .content-login {
                    margin-top: 40px;
                    margin-left: 40px;
                    border: none;
                    font-size: 18px;
                    line-height: 36px;
                    width: 80%;
                    outline: none;
                    color: #fff;
                    background-color: #1861b4;
                    &:hover:not(:disabled) {
                        background-color: #68e5f8;
                    }

                    &:active:not(:disabled) {
                        background-color: #16d8f5;
                    }
                }
            }
        }
    }
}
</style>
